
// Vue
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

// Components
import SureViewIcon from "@/components/SureViewIcon.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

// Types
import { VueBootstrapField } from '@/store/types';
import { Response } from "@/store/responses/types";

// Services
import ccureapi from "@/services/api.ccure.service";
import { BadgeActivityResponse } from '@/types/ccure/BadgeActivity';
import { formatDateMixin, DateString } from '@/mixins';

@Component({
	components: {
		"sureview-icon": SureViewIcon,
		"vue-perfect-scrollbar": VuePerfectScrollbar
	}
})
export default class BadgeActivityTable extends Vue {
	@Prop({ default: null, type: Object }) response?: Response | null;
	@Prop({ default: false, type: Boolean }) badgeActivityLoading!: boolean;

	private badgeActivities: BadgeActivityResponse[] = [];

	private tableLoading: boolean = false;

	private async created(): Promise<void> {
		if (this.response) {
			this.tableLoading = true;
			this.$emit('badge-activity-loading', true);
		}
	}

	@Watch("response", { deep: true })
	private async deviceIdChange(response: Response | null): Promise<void> {
		if (!response) {
			return;
		}
		this.tableLoading = true;
		this.$emit('badge-activity-loading', this.tableLoading);
	}

	@Watch("badgeActivityLoading")
	private async reFetchBadgeActivity(loadingStatus: boolean) {
		if (!this.response || !loadingStatus) {
			return;
		}

		await this.getBadgeActivity();
	}

	private get tableFields(): VueBootstrapField[] {
		return [
			{ key: 'objectOneName', label: 'Name' },
			{ key: 'messageType', label: 'Message Type' },
			{
				key: 'serverDateTime',
				label: 'UTC Date/Time',
				formatter: (date: DateString) => formatDateMixin.methods.displayDateFromISOString(date)
			},
			{
				key: 'areaDateTime',
				label: 'Area Date/Time',
				formatter: (date: DateString) => formatDateMixin.methods.displayDateFromISOString(date)
			},
			{ key: 'messageText', label: 'Message Text' }
		];
	}

	private async getBadgeActivity(): Promise<void> {
		const response = await ccureapi.getActivityBadgesByResponse(
			this.response.responseID,
			this.response.input1,
			this.response.input2,
			this.response.serverTypeEventNum);

		if (response.data) {
			this.badgeActivities = response.data;
		}

		this.tableLoading = false;
		this.$emit('badge-activity-loading', this.tableLoading);
	}

	private get isTableLoading() {
		return this.tableLoading || this.badgeActivityLoading;
	}
}
